/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-06-18 15:02:39
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\login\store.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';
import { setToken } from '@/utils/localToken';
import { accountLogin, getArea, pickupScope, getArea4PickupList, getStationAreaList } from './service';
import { LoginParamsType,AreaParams } from "./data.d";

export interface StateType {
    loginStatus?: 'ok' | 'error';
    userCode?: string;
    number?: string;
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType;
    mutations: {
        changeLoginStatus: Mutation<StateType>;
        setUserCode: Mutation<StateType>;
    };
    actions: {
        login: Action<StateType, StateType>;
        getAreaListFn: Action<StateType, StateType>;
        getPickupScopeFn: Action<StateType, StateType>;
        getArea4PickupListFn: Action<StateType, StateType>;
        getStationAreaListFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    loginStatus: undefined,
    userCode: '',
    number: ''
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'userlogin',
    state: {
        ...initState
    },
    mutations: {
        changeLoginStatus(state, payload) {
            state.loginStatus = payload;
        },
        setUserCode(state,value){
            state.userCode = value
        }
    },
    actions: {
        async login({ commit }, params: LoginParamsType) {
            let status: string | undefined = undefined;
            try {
                const response: ResponseData = await accountLogin(params);
                const { body } = response;
                // setToken(data.token || '');
                commit('setUserCode',body)
                localStorage.setItem('userCode',JSON.stringify(body))
                localStorage.getItem('loginbody')&&localStorage.removeItem('loginbody')
                status = 'ok';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    status = 'error';
                    const { response } = error;
                    const num = response.data.body || 0
                    localStorage.setItem('loginbody',num)
                }
            }
            commit('changeLoginStatus',status);

            if (status === 'ok') {
                return true;
            } else if (status === 'error') {
                return false;
            }
            return undefined;
        },
        async getAreaListFn({ commit }) {
            let status: string | undefined = undefined;
            try {
                const response: ResponseData = await getArea();
                const { body } = response;
                console.log(body)
                localStorage.setItem('areaList',JSON.stringify(body))
                status = 'ok';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    status = 'error';
                    const { response } = error;
                    const num = response.data.body || 0
                    localStorage.setItem('loginbody',num)
                }
            }
            commit('changeLoginStatus',status);

            if (status === 'ok') {
                return true;
            } else if (status === 'error') {
                return false;
            }
            return undefined;
        },
        async getPickupScopeFn({ commit }) {
            let status: string | undefined = undefined;
            try {
                const response: ResponseData = await pickupScope();
                const { body } = response;
                const pickData = body.filter((currentValue:any, currentIndex:any, selfArr:any) =>{
                    return selfArr.findIndex((x:any) => x.city === currentValue.city) === currentIndex
                });
                localStorage.setItem('pickupScopeList',JSON.stringify(pickData))
                status = 'ok';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    status = 'error';
                    const { response } = error;
                    const num = response.data.body || 0
                    localStorage.setItem('loginbody',num)
                }
            }
            commit('changeLoginStatus',status);

            if (status === 'ok') {
                return true;
            } else if (status === 'error') {
                return false;
            }
            return undefined;
        },
        async getArea4PickupListFn({ commit }, params:AreaParams){
            let msg: string | undefined = undefined
            try{
                const {body} = await getArea4PickupList(params)
                localStorage.setItem('Area4PickupList',JSON.stringify(body))
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }

            commit('changeErrorMsg',msg);

            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        async getStationAreaListFn({ commit }, params:AreaParams){
            let msg: string | undefined = undefined
            try{
                const {body} = await getStationAreaList(params)
                localStorage.setItem('stationAreaList',JSON.stringify(body))
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }

            commit('changeErrorMsg',msg);

            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        }
    }
}

export default StoreModel;
